var TypeAheadController = (function () {
    function TypeAheadController(topic, socket, DTS, $q, $timeout, $stateParams, $state, $scope, $attrs, env, notify, btnLabel, isReassign, usersFromCloudant) {
        var _this = this;
        this.topic = topic;
        this.socket = socket;
        this.DTS = DTS;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.env = env;
        this.notify = notify;
        this.btnLabel = btnLabel;
        this.isReassign = isReassign;
        this.usersFromCloudant = usersFromCloudant;
        this.viaActionMenu = false; // Default... ie: from Queues
        this.fired = false; // when button clicked for server update
        this.scopeId = this.DTS.guid();
        this.isManual = false;
        this.hasResult = false;
        this.hasText = false;
        this.isSelected = false;
        this.isDisabled = false;
        this.searchText = null;
        this.selectedItem = null;
        this.owner = { owner: '', newowner: '' };
        this.deferred = {};
        this.socket.forward('typeahead.' + this.scopeId, this.$scope);
        this.$scope.$on('socket:typeahead.' + this.scopeId, function (event, data) {
            _this.lookupowner(event, data);
            _this.usersFromCloudant = data.results;
        });
        this.socket.forward('typeahead.success');
        this.$scope.$on('socket:typeahead.success', function (event, data) {
            _this.fired = false;
            if (data.success) {
                // If fired from the action menu
                if (_this.viaActionMenu) {
                    _this.vm.cancel(); // close dialog
                    // if in Elig status or a Pre-Sales Order Validation status...and no owner allow... 
                    // gonna have to reload the whole thing, ffs, because the server-side code is not set-up nicely to pull 
                    // the the editable options as well as potential status-code etc...history, blah, blah
                    if (!_this.topic.hasOwner() &&
                        (!_this.topic.isNotInEligibilityStatus() ||
                            _this.topic.isValidationPreSalesOrder() ||
                            _this.topic.hasUnresolvedErrors() ||
                            _this.topic.isInitialV3())) {
                        // Reload
                        _this.topic.reloadDisbursement(_this.$stateParams.id);
                        _this.notify.success('Reloading Disbursement');
                    }
                    else {
                        // Update owner
                        _this.topic.topic.owner = data.newOwner;
                        _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                    }
                }
            }
        });
        if (this.$attrs.reassign) {
            if (this.$attrs.reassign === 'true') {
                this.btnLabel = 'Re-Assign';
                this.isReassign = true;
            }
            else {
                this.btnLabel = 'Assign';
                this.isReassign = false;
            }
        }
        else {
            if (this.$stateParams.id === 'myqueue' || this.$stateParams.id === 'teamqueue') {
                this.btnLabel = 'Re-Assign';
                this.isReassign = true;
            }
            else {
                this.btnLabel = 'Assign';
                this.isReassign = false;
            }
        }
    }
    TypeAheadController.prototype.lookupowner = function (event, data) {
        if (data.err) {
            return this.env.promises[data.id].reject([]);
        }
        this.env.promises[data.id].resolve(data.results);
        delete this.env.promises[data.id];
    };
    TypeAheadController.prototype.searchTextChange = function (text) {
        var t = this;
        if (!text) {
            this.hasText = false;
        }
        else {
            this.hasText = true;
            this.searchText = text;
        }
    };
    // returnCancel() {
    //     return this.$attrs.vms;
    // }
    TypeAheadController.prototype.selectedItemChange = function () {
        var t = this;
        if (!this.hasText) {
            this.isSelected = false;
            this.hasResult = false;
        }
        else {
            this.isSelected = true;
            this.hasResult = true;
        }
    };
    TypeAheadController.prototype.newPromise = function (socket) {
        var _this = this;
        var t = this;
        this.deferred = this.$q.defer();
        this.$timeout(function () {
            _this.deferred.reject([]);
        }, 5000);
        var id = this.DTS.guid();
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'lookUpUser',
                script: '/queue/typeahead',
                id: id,
                scope: this.scopeId,
                adminOnly: true,
                country: this.topic.topic.country || this.$attrs.country,
                token: this.env.user.token
            }
        });
        this.env.promises[id] = this.deferred;
        return this.deferred.promise;
    };
    TypeAheadController.prototype.$onInit = function () {
        if (angular.isDefined(this.vm) && angular.isDefined('clickOutsideToClose')) {
            this.viaActionMenu = true;
        }
        this.querySearch();
    };
    TypeAheadController.prototype.querySearch = function () {
        return this.newPromise(this.socket);
    };
    TypeAheadController.prototype.querySearchByCountry = function (query) {
        var results = query ? this.createFilterByInput(query) : this.usersFromCloudant;
        return results;
    };
    TypeAheadController.prototype.createFilterByInput = function (query) {
        query = query.toLowerCase();
        return this.usersFromCloudant.filter(function (user) { return user.name.toLowerCase().includes(query); });
    };
    TypeAheadController.prototype.isEnabled = function () {
        if (this.vm === undefined) {
            return true;
        }
        else {
            if (!this.viaActionMenu) {
                return this.vm.isSelected();
            }
            else {
                return true;
            }
        }
    };
    TypeAheadController.prototype.changeOwner = function (item) {
        var opps;
        if (angular.isDefined(this.vm) && !this.viaActionMenu) {
            if (this.isReassign) {
                return this.vm.reAssign(item.email);
            }
            else {
                return this.vm.assign(undefined, item.email);
            }
        }
        else {
            this.fired = true;
            // opps = { opp: this.$attrs.opp, bpname: this.$attrs.bpname, status: this.$attrs.status }; 
            opps = { opp: this.$attrs.opp, bpname: this.$attrs.bpname };
            // If sub-status is Unassigned (ie: new claim in Received, or in Validation after an WOV update)
            if ((this.$attrs.substatus && this.$attrs.substatus === 'Unassigned') || this.$attrs.status === 'Validation') {
                opps.status = this.$attrs.status; // Send the main status
            }
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'assignRequests',
                    script: '/queueservice/assign',
                    data: {
                        currentUser: this.env.user.email,
                        opps: [opps],
                        email: item.email,
                        reassign: this.isReassign,
                        notifications: this.env.notifications
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    TypeAheadController.$inject = ['topic', 'socket', 'DTS', '$q', '$timeout',
        '$stateParams', '$state', '$scope', '$attrs', 'env', 'notify'];
    return TypeAheadController;
}());
var TypeAheadComponent = (function () {
    function TypeAheadComponent() {
        this.templateUrl = 'typeahead.html';
        this.bindings = { vm: '<' };
        this.controller = TypeAheadController;
    }
    return TypeAheadComponent;
}());
angular
    .module('application')
    .component('typeAhead', new TypeAheadComponent());

//# sourceMappingURL=typeahead.component.js.map
